<template>
  <div>
    <v-layout>
      <v-btn color="success" @click="showEditModal" v-if="isWriteAvailable">
        Add speaker
      </v-btn>
      <v-btn color="primary" @click="downloadExcel('speakers')">Download Speakers</v-btn>
      <v-flex xs3 class="my-3 ml-5">
        <v-layout>
          Published: {{counterStatus.published}}
          <v-spacer/>
          Draft: {{counterStatus.draft}}
          <v-spacer/>
          Deleted: {{counterStatus.deleted}}
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs8 offset-xs4 class="mt-2 mb-4">
        <v-layout>
          <v-flex xs-3>
            <v-text-field
              append-icon="search"
              label="Name"
              single-line
              hide-details
              v-model="filterSpeaker.name"
            />
          </v-flex>
          <v-spacer/>
          <v-flex xs-3 offset-xs1>
            <v-text-field
              append-icon="search"
              label="Company"
              single-line
              hide-details
              v-model="filterSpeaker.company"
            />
          </v-flex>
          <v-spacer/>
          <v-flex xs-3 offset-xs1>
            <v-text-field
              append-icon="search"
              label="Job Title"
              single-line
              hide-details
              v-model="filterSpeaker.jobTitle"
            />
          </v-flex>
          <v-flex xs-3 offset-xs1>
            <v-text-field
              append-icon="search"
              label="Session"
              single-line
              hide-details
              v-model="filterSpeaker['agendaSessions.ShortDescription']"
            />
          </v-flex>
          <v-flex xs-1 offset-xs1>
            <v-btn color="primary" dark class="mb-2" @click="reset">Reset</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-data-table
      v-if="getSpeakers"
      :headers="headers"
      :items="getSpeakers"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          <v-flex>
            {{ props.item.name || 'No name' }}
          </v-flex>
        </td>

        <td class="text-xs-center">{{ props.item.company }}</td>
        <td class="text-xs-center">{{ props.item.status }}</td>
        <td class="text-xs-center">{{props.item.speakerType}}</td>
        <td class="text-xs-center">{{props.item.jobTitle}}</td>
        <td class="text-xs-center">{{getDate(props.item.updateDate)}}</td>
        <td v-if="!getIsManager" class="text-xs-center">{{getAdminByPackage(props.item.lastEditorId)}}</td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="lime"
              :disabled="!isWriteAvailable"
              fab flat
              slot="activator"
              @click="showEditModal(props.item.id)"
            >
              <v-icon>create</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="blue-grey darken-2"
              :disabled="!isWriteAvailable"
              fab flat
              slot="activator"
              @click="publishSpeaker(props.item.id)"
            >
              <v-icon>publish</v-icon>
            </v-btn>
            <span>Publish</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="orange"
              :disabled="!isWriteAvailable"
              fab flat
              slot="activator"
              @click="draftSpeaker(props.item.id)"
            >
              <v-icon>description</v-icon>
            </v-btn>
            <span>Draft</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              :disabled="!isWriteAvailable"
              color="error"
              fab flat
              slot="activator"
              @click="deleteSpeaker(props.item.id)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data" v-if="!getSpinnerVisibilityStatus">
        <v-alert :value="true" color="error" icon="warning">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
    </v-data-table>

    <v-dialog
      v-model="isEditFormVisible"
      fullscreen
      persistent
      transition="dialog-bottom-transition"
      :overlay="false"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon @click.native="hideEditModal" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ modalMode }} speaker
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              flat
              @click.native="saveSpeaker"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div v-if="isEditFormVisible">
            <h2>Predefined fields</h2>
            <content-field
              label="Name"
              v-model="speaker.name"
              :error="$v.speaker.name"
              @input="$v.speaker.name.$touch()"
              @blur="$v.speaker.name.$touch()"
            />
            <content-field
              label="Company"
              v-model="speaker.company"
              :error="$v.speaker.company"
              @input="$v.speaker.company.$touch()"
              @blur="$v.speaker.company.$touch()"
            />
            <content-field
              label="Job Title"
              v-model="speaker.jobTitle"
              :error="$v.speaker.jobTitle"
              @input="$v.speaker.jobTitle.$touch()"
              @blur="$v.speaker.jobTitle.$touch()"
            />
            <content-field
              label="Email"
              v-model="speaker.email"
              :error="$v.speaker.email"
              @input="$v.speaker.email.$touch()"
              @blur="$v.speaker.email.$touch()"
            />
            <h3>Set type:</h3>
            <v-radio-group
              :mandatory="true"
              v-model="speaker.speakerType"
            >
              <v-radio
                v-for="(type,i) in ['Regular', 'Featured']"
                :key="'type'+i"
                :label="type"
                :value="type"
              />
            </v-radio-group>

            <h3>Permission to contact:</h3>
            <v-switch
              :label="`${speaker.canReceiveMessages ? 'Enable ' : 'Disable '} contact`"
              v-model="speaker.canReceiveMessages"
            />
            <div class="upload-image-wrapper">
              <h3>Upload Image</h3>
              <v-flex class="py-1">
                <v-avatar v-if="speaker.image" :tile="true">
                  <img :src="speaker.image">
                </v-avatar>
                <v-btn
                  v-if="speaker.image"
                  color="error"
                  @click="removeImage('image')"
                >Remove image
                </v-btn>
                <a-upload-section
                  class="upload-button"
                  :btnAppearance="btnAppearance"
                  @lastUploadedPhotos="handleChosenImage('image', $event)"
                />
              </v-flex>
              <div
                v-if="$v.speaker.image.$invalid && $v.speaker.image.$dirty"
                class="error-message"
              >The field is required
              </div>
            </div>
            <div class="upload-image-wrapper">
              <h3>Image on hover</h3>
              <v-flex class="py-1">
                <v-avatar v-if="speaker.hoverImage" :tile="true">
                  <img :src="speaker.hoverImage">
                </v-avatar>
                <v-btn
                  v-if="speaker.hoverImage"
                  color="error"
                  @click="removeImage('hoverImage')"
                >Remove image
                </v-btn>
                <a-upload-section
                  class="upload-button"
                  :btnAppearance="btnAppearance"
                  @lastUploadedPhotos="handleChosenImage('hoverImage', $event)"
                />
              </v-flex>
              <div
                v-if="$v.speaker.hoverImage.$invalid && $v.speaker.hoverImage.$dirty"
                class="error-message"
              >The field is required
              </div>
            </div>

            <e-color-picker
              label="Hover color"
              :value="speaker.hoverColor"
              @colorChange="onHoverColorChange($event)"
            />
            <content-editor
              label="Biography"
              v-model="speaker.biography"
              @blur="$v.speaker.biography.$touch()"
              :error="$v.speaker.biography"
            />
            <v-layout row class="sessions-group" v-if="modalMode === 'Edit'">
              <v-flex xs12>
                <h3>Choose sessions:</h3>
                <v-checkbox
                  :label="session.shortDescription"
                  :value="session.id"
                  v-model="checkedSessions"
                  v-for="session in filteredSessions"
                  :key="`${session.id}`"
                />
              </v-flex>
            </v-layout>

            <h2>Custom fields</h2>
            <!-- was change from getFormData to currentForm it's solve problem with duble request speaker_registration-->
            <form-interpretator
              v-if="currentForm"
              :formType="currentForm.type"
              :formId="currentForm.id"
              :formGroup="currentForm.group"
              :formFields="currentForm.fields"
              :formMetadata="currentForm.metadata"
              :editableItem="speaker.metadataObject"
              @submit="getSubmittedFormData($event)"
              ref="formInterpretator"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EColorPicker from '@/components/shared/EColorPicker'
import FormInterpretator from '@/components/shared/EvFormInterpretator'
import AUploadSection from '@/components/shared/AUploadSection'
import { required, email } from 'vuelidate/lib/validators'
import debounce from 'lodash.debounce'
import { timeSettings } from '@/modules/settings/'
import { assocPath, path, prop, equals, compose, head, pathOr, clone } from 'ramda'
import mixins from '@/utils/mixins'
import { merge } from 'ramda'

export default {
  name: 'SpeakersTable',
  mixins: [mixins.isWriteAvailable],
  components: {
    EColorPicker,
    FormInterpretator,
    AUploadSection
  },
  data () {
    return {
      modalMode: 'Add',
      isEditFormVisible: false,
      checkedSessions: [],
      initiallyCheckedSessions: [],
      sessionsForEdit: [],
      filteredSessions: [],
      speaker: {
        name: '',
        company: '',
        jobTitle: '',
        email: '',
        speakerType: 'Regular',
        canReceiveMessages: false,
        image: null,
        hoverImage: null,
        hoverColor: { hex: '#eeeeee' },
        biography: '',
        metadataObject: {}
      },
      filterSpeaker: {
        jobTitle: '',
        company: '',
        name: '',
        'agendaSessions.shortDescription': ''
      },
      headers: [
        { text: 'Speaker', value: 'name', sortable: true, align: 'center', width: 150 },
        { text: 'Company', value: 'company', sortable: true, align: 'center', width: 200 },
        { text: 'Status', value: 'status', sortable: true, align: 'center' },
        { text: 'Type', value: 'speakerType', sortable: true, align: 'center' },
        { text: 'Job Title', value: 'jobTitle', sortable: true, align: 'center' },
        { text: 'Last Modified Date', value: 'updateDate', sortable: true, align: 'center' },
        { text: 'User Modified', value: 'lastEditorId', sortable: true, align: 'center' },
        { text: 'Edit', sortable: false, align: 'center' },
        { text: 'Publish', sortable: false, align: 'center' },
        { text: 'Draft', sortable: false, align: 'center' },
        { text: 'Delete', sortable: false, align: 'center' }
      ],
      pagination: {sortBy: 'updateDate', descending: true},
      chosenImageType: '',
      formData: {},
      counterStatus: {},
      counterStatusDefault: {
        published: 0,
        draft: 0,
        deleted: 0
      },
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'speakers:write',
      btnAppearance: {
        text: 'Choose Image',
        color: 'success',
        raised: true,
        hideIcon: true
      }
    }
  },
  validations: {
    speaker: {
      name: { required },
      company: { required },
      jobTitle: { required },
      email: {
        required,
        email
      },
      biography: { required },
      image: { required },
      hoverImage: { required }
    }
  },
  computed: {
    ...mapGetters([
      'getSpinnerVisibilityStatus',
      'getFormData',
      'getSpeakers',
      'sessionsList',
      'getUsersListWithCurrentUser',
      'getSettings',
      'currentForm',
      'getIsManager'
    ])
  },
  watch: {
    sessionsList (newVal) {
      if (newVal.length) {
        this.filterSessions()
      }
    },
    getSpeakers: {
      handler (val) {
        if (val.length === 0) return
        this.changeCounterStatus()
      },
      deep: true
    },
    filterSpeaker: {
      handler (filterSpeaker) {
        this.getSpeakersList({ filterSpeaker })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'getInterpritationFormData',
      'fetchSpeakersList',
      'deleteSpeakerById',
      'getSessionsList',
      'publishSpeakerById',
      'draftSpeakerById',
      'fetchUsers',
      'editSession',
      'editSpeaker',
      'createSpeaker',
      'downloadExcel'
    ]),
    path,
    filterSessions () {
      this.sessionsList.forEach((session) => {
        const sessionLocation = path(['location'], session)
        const isSessionStatusPublish = path(['status'], session) === 'Publish'
        const { startDate: eventStartTime, endDate: eventEndTime } = pathOr('', ['agendaSetting', 'eventConfiguration'], this.getSettings)
        const currentMomentOfTimeInISO = (new Date()).toISOString()
        const isSessionProperTimeRange = session.startTime > eventStartTime && session.endTime < eventEndTime && session.startTime > currentMomentOfTimeInISO
        const isSessionAvailable = sessionLocation && isSessionStatusPublish && isSessionProperTimeRange
        if (isSessionAvailable) {
          this.filteredSessions = [...this.filteredSessions, session]
        }
      })
    },
    getSessionsOfSpeaker (speakerId) {
      this.sessions = []

      this.filteredSessions.forEach((session) => {
        const thisSessionSpeakers = session.speakers
        if (thisSessionSpeakers.length) {
          const speakerStatus = thisSessionSpeakers.some((speaker) =>  (speaker['id'] === speakerId))
          if (speakerStatus) {
            this.checkedSessions = [...this.checkedSessions, session['id']]
            this.initiallyCheckedSessions = [...this.initiallyCheckedSessions, session['id']]
          }
        }
      })
    },
    showEditModal (speakerId) {
      this.checkedSessions = []
      this.initiallyCheckedSessions = []
      this.sessionsForEdit = []
      if (typeof speakerId === 'string') {
        this.modalMode = 'Edit'
        this.checkedSessions = []
        this.getSessionsOfSpeaker(speakerId)
      } else {
        this.modalMode = 'Add'
      }
      this.speaker = this.getSpeakers.find((item) => {
        if (speakerId === item.id) {
          return item
        }
      })
      if (!this.speaker) {
        this.speaker = {
          name: '',
          company: '',
          jobTitle: '',
          speakerType: 'Regular',
          canReceiveMessages: false,
          image: '',
          hoverImage: '',
          hoverColor: { hex: '#e21e21' },
          biography: '',
          metadataObject: {}
        }
        this.checkedSessions = []
        this.initiallyCheckedSessions = []
      } else {
        this.speaker = assocPath(['metadataObject', 'metadata'], this.speaker.metadata, this.speaker)
        this.speaker.hoverColor = { hex: this.speaker.hoverColor }
      }
      this.isEditFormVisible = true
    },
    hideEditModal () {
      this.isEditFormVisible = false
    },
    onHoverColorChange (newColor) {
      this.speaker.hoverColor = newColor
    },
    deleteSpeaker (speakerId) {
      this.deleteSpeakerById([speakerId])
    },
    draftSpeaker (speakerId) {
      this.draftSpeakerById([speakerId])
    },
    publishSpeaker (speakerId) {
      this.publishSpeakerById([speakerId])
    },
    getSessionsToAddSpeaker () {
      this.checkedSessions.forEach((sessionId) => {
        if (!this.initiallyCheckedSessions.includes(sessionId)) {
          // speaker was added to session
          this.filteredSessions.forEach(session => {
            if (session.id === sessionId) {
              const sessionForEdit = {}
              const sessionSpeakersIds = session.speakers.map(speaker => speaker.id)
              sessionSpeakersIds.push(this.speaker.id)
              sessionForEdit.id = sessionId
              sessionForEdit.speakersIds = sessionSpeakersIds
              const editedSession = merge(session, sessionForEdit)
              this.sessionsForEdit = [...this.sessionsForEdit, editedSession]
            }
          })
        }
      })
    },
    getSessionsToDeleteSpeaker () {
      this.initiallyCheckedSessions.forEach((sessionId) => {
        if (!this.checkedSessions.includes(sessionId)) {
          // speaker was deleted from session
          this.filteredSessions.forEach(session => {
            if (session.id === sessionId) {
              const sessionForEdit = {}
              const sessionSpeakersIds = session.speakers
                .map(prop('id'))
                .filter(id => (id !== this.speaker.id)) // TODO: refactor
              sessionForEdit.id = sessionId
              sessionForEdit.speakersIds = sessionSpeakersIds
              const editedSession = merge(session, sessionForEdit)
              this.sessionsForEdit = [...this.sessionsForEdit, editedSession]
            }
          })
        }
      })
    },
    async saveSessions () {
      this.getSessionsToAddSpeaker()
      this.getSessionsToDeleteSpeaker()
      const editSessionsPromises = this.sessionsForEdit.map((session)=>{
        const currentSession = clone(session)
        currentSession.locationId = currentSession.location.id
        delete currentSession.location
        delete currentSession.speakers
        return this.editSession(currentSession)
      })
      try {
        await Promise.all(editSessionsPromises)
      } catch (err) {
        console.error(err)
        throw err
      }
    },
    async saveSpeaker () {
        this.$refs.formInterpretator.submitForm()
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }
        this.speaker.hoverColor = this.speaker.hoverColor.hex
      try {
        if (this.modalMode === 'Edit') {
          await this.editSpeaker(this.speaker)
          await this.saveSessions()
        } else {
          await this.createSpeaker(this.speaker)
        }
        this.fetchSpeakersList({ filterSpeaker: { ...this.filterSpeaker } })
        this.getSessionsList({ filter: { sessionType: 'Regular' } })
        this.filteredSessions = []
        this.isEditFormVisible = false
      } catch (err) {
        console.error(err)
      }
    },
    handleChosenImage (imageType, photos) {
      const choseUrl = (urls) => urls.small || urls.medium || urls.large || urls.originalImageUrl
      this.speaker[imageType] = compose(choseUrl, pathOr({}, ['imagesUrls']), head)(photos)
    },
    getSpeakersList: debounce(function (payload) {
      this.fetchSpeakersList(payload)
    }, timeSettings.delayTime),
    getSubmittedFormData (formData) {
      this.speaker.metadataObject = formData
    },
    changeCounterStatus () {
      this.counterStatus = Object.assign({}, this.counterStatusDefault)
      this.getSpeakers.forEach(elem => {
        const statusName = path(['status'], elem)
        if (statusName) {
          this.counterStatus[statusName.toLowerCase()]++
        }
      })
    },
      getDate (date) {
        const d = new Date(date)
        const month = d.getMonth() + 1
        const day = d.getDate()
        const year = d.getUTCFullYear()
        return `${month} / ${day} / ${year}`
      },
      getAdminByPackage (lastModifiedAdminId) {
        if (this.getUsersListWithCurrentUser.length === 0) return
        if (lastModifiedAdminId) {
          const adminThatDidEditLast = this.getUsersListWithCurrentUser.find(user => user.id === lastModifiedAdminId)
          return adminThatDidEditLast ? adminThatDidEditLast.userName : ''
        }
        return ''
      },
      removeImage (img) {
        this.speaker[img] = ''
      },
      reset () {
        Object.keys(this.filterSpeaker).forEach(val => this.filterSpeaker[val] = '')
        this.getSpeakersList()
      }
    },
    async created () {
      //  await this.getInterpritationFormData('speaker_registration')
      await this.getSpeakersList()
      await this.getSessionsList({ filter: {sessionType: 'Regular'} })
      if (this.getIsManager) {
        this.headers = this.headers.filter(header => header.value !== 'lastEditorId')
        return
      }
      await this.fetchUsers()
    }
  }
</script>

<style scoped>
.upload-image-wrapper {
  position: relative;
  margin-bottom: 10px;
}

.error-message {
  font-size: 13px;
  color: #ff171e;
  position: absolute;
  bottom: -10px;
}

.sessions-group /deep/ .input-group {
  width: 250px;
  display: inline-block !important;
}

.upload-button {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Speakers/Table/index.vue